import React from 'react';
import * as Row from '../../../layout/Row';
import ExpandableContainer from '../ExpandableContainer';

export default class SummaryEESLabelSection extends React.Component {
    render() {


        if (this.props.model.unitType.isCustomLogic.value)
            return (<React.Fragment></React.Fragment>)

        if (this.props.model.ees == null)
            return '';
        return (
            <ExpandableContainer label={__('EES Label')}>
                <Row.Container hasOuterGutter={false} className="flex-center-v">
                    <Row.Column6>
                        <div className="configuration-editor-summary-table-wrapper">
                            <table className="configuration-editor-summary-table">
                                <thead>
                                <tr>
                                    <th>{__('Category')}</th>
                                    <th>{__('Points')}</th>
                                </tr>
                                </thead>

                                <tbody>
                                {this.props.model.ees.items.map((c, idx) => (
                                    <tr key={idx}>
                                        <td>{c.category}</td>
                                        <td>{c.currentPoints} / {c.maximumPoints}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </Row.Column6>

                    <Row.Column6>
                        <div className="flex-center flex-dir-col">
                            <span className={`configuration-editor-summary-ees-label--${this.props.model.ees.label}`}>
                                {this.props.model.ees.label}
                            </span>
                            <span
                                className="text-muted">{this.props.model.ees.currentPoints} / {this.props.model.ees.maximumPoints}</span>
                        </div>
                    </Row.Column6>
                </Row.Container>
            </ExpandableContainer>
        )
    }
}